import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface ProductoDetalle {
  nombre: string;
  codigo: string;
  precio: number | string;
  stock: number;
  descripcion?: string;
  ingredientes?: string;
  beneficios?: string;
  modoUso?: string;
  unidadMedida?: string;
  contenido?: string | number;
}

@Component({
  selector: 'app-product-detail-dialog',
  templateUrl: './product-detail-dialog.component.html',
  styleUrls: ['./product-detail-dialog.component.scss']
})
export class ProductDetailDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ProductoDetalle,
    private dialogRef: MatDialogRef<ProductDetailDialogComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  get precioUnitario(): number {
    const valor = Number(this.data.precio);
    return isNaN(valor) ? 0 : valor;
  }

  get descripcion(): string {
    return this.data.descripcion?.trim() || 'No especificada';
  }

  get ingredientes(): string {
    return this.data.ingredientes?.trim() || 'No especificados';
  }

  get modoUso(): string {
    return this.data.modoUso?.trim() || 'No especificado';
  }

  get beneficios(): string {
    return this.data.beneficios?.trim() || 'No especificados';
  }
}

